export default {
    methods: {
        /**
         * Push a notification to the screen.
         * Uses Toasts
         * @link https://bootstrap-vue.org/docs/components/toast
         * @param message
         * @param color
         * @param errors
         */
        popNotification(message, color = 'danger', errors = null, persist = false) {
            const h = this.$createElement;

            let vNodeMessage;
            if (errors !== null) {
                let errorList = errors.map(error => h('li', error));
                const errorUl = h('ul', { class: ['my-0'] }, errorList);

                vNodeMessage = h('div', [
                    h('p', message),
                    errorUl
                ]);
            } else {
                vNodeMessage = h('div', { domProps: { innerHTML: message } });
            }

            // Log error to backend if color is 'danger' or 'warning'
            if (color === 'danger' || color === 'warning') {
                this.sendErrorToBackend(message, errors);
            }

            this.$bvToast.toast(vNodeMessage, {
                autoHideDelay: 7000,
                variant: color,
                appendToast: true,
                noAutoHide: persist,
                noCloseButton: !persist,
                html: true
            });
        },
        sendErrorToBackend(message, errors = null) {
            const errorData = {
                message: message,
                errors: errors,
                url: window.location.href
            };

            this.$http.post('/http_api/log-error', errorData)
                .catch(error => {
                    console.error('Failed to log error to backend:', error);
                });
        }

    }
};